import { BasicRegisterDialogProperties } from "@goodgamestudios/core";
import { BasicUserEvent } from "@goodgamestudios/core";
import { TextFieldHelper } from "@goodgamestudios/core";
import { LanguageDataEvent } from "@goodgamestudios/core";
import { CommonDialogNames } from "@goodgamestudios/core";
import { BasicController } from "@goodgamestudios/core";
import { BasicLayoutManager } from "@goodgamestudios/core";
import { BasicModel } from "@goodgamestudios/core";
import { CommandController } from "@goodgamestudios/core";
import { BasicStandardOkDialogProperties } from "@goodgamestudios/core";
import { TextFieldWatcher } from "@goodgamestudios/core";
import { TextValide } from "@goodgamestudios/core";

import { navigateToURL } from "@goodgamestudios/createjs-utilities";
import { KeyboardEvent } from "@goodgamestudios/createjs-utilities";
import { TextFormat } from "@goodgamestudios/createjs-utilities";
import { URLRequest } from "@goodgamestudios/createjs-utilities";

import { int } from "@goodgamestudios/math-utilities";

import { SFConstants } from "../../../constants/SFConstants";
import { ErrorCodes } from "../../../constants/shared/ErrorCodes";
import { AvatarCreationEvent } from "../../../event/AvatarCreationEvent";
import { Poker2UserEvent } from "../../../event/Poker2UserEvent";
import { Poker2Model } from "../../../model/Poker2Model";
import { InputFieldConstants } from "../../constants/InputFieldConstants";
import { Poker2Dialog } from "../Poker2Dialog";
import { Poker2NameSelection } from "../Poker2NameSelection";

import Container = createjs.Container;
import Event = createjs.Event;
import FocusEvent = createjs.FocusEvent;
import MouseEvent = createjs.MouseEvent;
import TextEvent = createjs.TextEvent;
import Rectangle = createjs.Rectangle;

export class Poker2RegisterDialog extends Poker2Dialog {
    public static NAME: string;
    private isWaitingForServerMessage: boolean = false;
    private preset_name: string = "";
    private preset_mail: string = "";
    private preset_pass: string = "";
    private nameSelectionToolTip: Poker2NameSelection;

    private lastTextFieldWatcherType: number = -1;
    private lastTextFieldWatcherMeldung: string;
    public static ERROR_USERNAME: number = 0;
    public static ERROR_MAIL: number = 1;
    public static ERROR_PASS: number = 2;
    public static ERROR_AGB: number = 3;

    constructor(disp: Container) {
        CONSTRUCTOR_HACK;
        super(disp);
    }

    public get registerDialogProperties(): BasicRegisterDialogProperties {
        return this.properties as BasicRegisterDialogProperties;
    }

    public get registerDialog(): Library.PokerInterface.PokerRegister {
        return this.disp as Library.PokerInterface.PokerRegister;
    }

    protected init(): void {
        super.init();
        this.controller.addEventListener(BasicUserEvent.REGISTERED, this.bindFunction(this.onRegisterCompleted));
        this.controller.addEventListener("avatarnamesuggestions", this.bindFunction(this.onShowNameSuggestion));
        this.controller.addEventListener("registerFailed", this.bindFunction(this.onRegisterFailed));

        this.registerDialog.txt_name.tabIndex = 1;
        this.registerDialog.txt_email.tabIndex = 2;
        this.registerDialog.txt_password.tabIndex = 3;
        this.registerDialog.txt_name.alpha = InputFieldConstants.INPUT_EMPTY_ALPHA;
        this.registerDialog.txt_email.alpha = InputFieldConstants.INPUT_EMPTY_ALPHA;
        this.registerDialog.txt_password.alpha = InputFieldConstants.INPUT_EMPTY_ALPHA;
        this.registerDialog.txt_password.displayAsPassword = true;
        this.registerDialog.txt_email.addEventListener(TextEvent.TEXT_INPUT, this.bindFunction(this.onEnterEmail));
        this.registerDialog.txt_password.addEventListener(TextEvent.TEXT_INPUT, this.bindFunction(this.onEnterPassword));
        this.registerDialog.txt_name.addEventListener(TextEvent.TEXT_INPUT, this.bindFunction(this.onEnterUsername));
        this.registerDialog.txt_email.addEventListener(FocusEvent.FOCUS_IN, this.bindFunction(this.onEnterEmail));
        this.registerDialog.txt_password.addEventListener(FocusEvent.FOCUS_IN, this.bindFunction(this.onEnterPassword));
        this.registerDialog.txt_name.addEventListener(FocusEvent.FOCUS_IN, this.bindFunction(this.onEnterUsername));
        this.registerDialog.txt_email.addEventListener(FocusEvent.FOCUS_OUT, this.bindFunction(this.refillEmptyInputFields));
        this.registerDialog.txt_password.addEventListener(FocusEvent.FOCUS_OUT, this.bindFunction(this.refillEmptyInputFields));
        this.registerDialog.txt_name.addEventListener(FocusEvent.FOCUS_OUT, this.bindFunction(this.refillEmptyInputFields));
        this.registerDialog.txt_name.maxChars = this.env.maxUsernameLength;
        this.registerDialog.txt_name.condenseWhite = true;

        // get input field defaults
        this.preset_name = Poker2Model.languageData.getTextById("generic_register_insertName");
        this.preset_mail = Poker2Model.languageData.getTextById("generic_register_insertEmail");
        this.preset_pass = Poker2Model.languageData.getTextById("generic_register_insertPassword");

        this.initTextFields();
    }

    protected onKeyUp(event: KeyboardEvent): void {
        this.saveFilledInputs();
    }

    protected onFontsLoaded(event: LanguageDataEvent): void {
        // hide suggestion bubbles
        this.hideNameSelection();
        // hide errors
        this.registerDialog.mc_errorbubble.visible = false;

        // init static textfields
        this.initTextFields();

        // get input field defaults
        this.preset_name = Poker2Model.languageData.getTextById("generic_register_insertName");
        this.preset_mail = Poker2Model.languageData.getTextById("generic_register_insertEmail");
        this.preset_pass = Poker2Model.languageData.getTextById("generic_register_insertPassword");

        // reset all fields
        this.resetInputTextFields();

        // fill in eiher data from properties or saved input data
        this.fillInSavedInputData();

        // refill presets
        this.refillEmptyInputFields();

        this.registerDialog.btn_agb.deselected();
        this.drawAvatar();
    }

    protected applyProperties(): void {
        super.applyProperties();

        // reset agb checkbox
        this.registerDialog.btn_agb.deselected();

        // reset all fields
        this.resetInputTextFields();

        // fill in either data from properties or saved input data
        this.fillInSavedInputData();

        // refill presets
        this.refillEmptyInputFields();

        this.drawAvatar();
    }

    private resetInputTextFields(): void {
        this.registerDialog.txt_name.text = "";
        this.registerDialog.txt_name.alpha = InputFieldConstants.INPUT_EMPTY_ALPHA;
        this.registerDialog.txt_email.text = "";
        this.registerDialog.txt_email.alpha = InputFieldConstants.INPUT_EMPTY_ALPHA;
        this.registerDialog.txt_password.text = "";
        this.registerDialog.txt_password.alpha = InputFieldConstants.INPUT_EMPTY_ALPHA;
    }

    private fillInSavedInputData(): void {
        // check if username is defined in dialog properties
        var presetUsername: string = (this.properties && this.registerDialogProperties.username) ? this.registerDialogProperties.username : "";

        // check if a username has been saved in registration data
        if (presetUsername == "" && Poker2Model.registrationData.userName) {
            presetUsername = Poker2Model.registrationData.userName;
        }

        // fill in user name, if available
        if (presetUsername && presetUsername != "") {
            this.registerDialog.txt_name.text = presetUsername;
            this.registerDialog.txt_name.alpha = InputFieldConstants.INPUT_FILLED_ALPHA;
        }

        // fill in email, if available
        if (Poker2Model.registrationData.email && Poker2Model.registrationData.email != "") {
            this.registerDialog.txt_email.text = Poker2Model.registrationData.email;
            this.registerDialog.txt_email.alpha = InputFieldConstants.INPUT_FILLED_ALPHA;
        }

        // fill in password, if available
        if (Poker2Model.registrationData.password && Poker2Model.registrationData.password != "") {
            this.registerDialog.txt_password.displayAsPassword = true;
            this.registerDialog.txt_password.text = Poker2Model.registrationData.password;
            this.registerDialog.txt_password.alpha = InputFieldConstants.INPUT_FILLED_ALPHA;
        }
    }

    private drawAvatar(): void {
        while (this.registerDialog.mc_holder.numChildren > 0)
            this.registerDialog.mc_holder.removeChildAt(0);

        if (Poker2Model.avatarData.myAvatar == null) {
            // todo: show Dummy
            return;
        }
        var mcAvatar: Container = AvatarHelper.drawAvatarByItemArray(Poker2Model.avatarData.getAvatarClothesArray(Poker2Model.avatarData.myAvatar), !this.layoutManager.inGameState);
        var bounds: Rectangle = mcAvatar.getBounds(null);

        var scaleFactor: number = (155 / bounds.width);

        if ((210 / bounds.height) > scaleFactor)
            scaleFactor = (210 / bounds.height);
        mcAvatar.scaleX = mcAvatar.scaleY = scaleFactor;
        mcAvatar.x = -((bounds.width * scaleFactor) / 2 + (bounds.left * scaleFactor));
        mcAvatar.y = -(bounds.top * scaleFactor);

        this.registerDialog.mc_holder.addChild(mcAvatar);
    }

    private onEnterEmail(event: Event): void {
        if (this.registerDialog.txt_email.text == this.preset_mail) {
            this.registerDialog.txt_email.text = "";
            this.registerDialog.txt_email.alpha = InputFieldConstants.INPUT_EMPTY_ALPHA;
        }
        else {
            this.registerDialog.txt_email.alpha = InputFieldConstants.INPUT_FILLED_ALPHA;
        }
    }

    private onEnterUsername(event: Event): void {
        if (this.registerDialog.txt_name.text == this.preset_name) {
            this.registerDialog.txt_name.text = "";
            this.registerDialog.txt_name.alpha = InputFieldConstants.INPUT_EMPTY_ALPHA;
        }
        else {
            this.registerDialog.txt_name.alpha = InputFieldConstants.INPUT_FILLED_ALPHA;

        }
    }

    private onEnterPassword(event: Event): void {
        if (this.registerDialog.txt_password.text == this.preset_pass) {
            this.registerDialog.txt_password.text = "";
            this.registerDialog.txt_password.alpha = InputFieldConstants.INPUT_EMPTY_ALPHA;
            this.registerDialog.txt_password.displayAsPassword = true;
        }
        else {
            this.registerDialog.txt_password.alpha = InputFieldConstants.INPUT_FILLED_ALPHA;
        }
    }

    private refillEmptyInputFields(event: Event = null): void {
        if (this.registerDialog.txt_email.text == "") {
            this.registerDialog.txt_email.text = this.preset_mail;
            this.registerDialog.txt_email.alpha = InputFieldConstants.INPUT_EMPTY_ALPHA;
        }

        if (this.registerDialog.txt_name.text == "") {
            this.registerDialog.txt_name.text = this.preset_name;
            this.registerDialog.txt_name.alpha = InputFieldConstants.INPUT_EMPTY_ALPHA;
        }

        if (this.registerDialog.txt_password.text == "") {
            this.registerDialog.txt_password.text = this.preset_pass;
            this.registerDialog.txt_password.displayAsPassword = false;
            this.registerDialog.txt_password.alpha = InputFieldConstants.INPUT_EMPTY_ALPHA;
        }
    }

    private initTextFields(): void {
        //Gästebereich fällt erstmal weg
        /*			registerDialog.btn_guest.minWidth = 190;
                    registerDialog.btn_guest.label = Poker2Model.languageData.getTextById("login_btn_guest");
                    registerDialog.btn_guest.visible = !env.campainVars.isValid() && layoutManager.outGameState;*/

        this.registerDialog.btn_guest.visible = false;

        this.registerDialog.btn_register.minWidth = 260;
        this.registerDialog.btn_register.label = Poker2Model.languageData.getTextById("generic_register_btn_save");
        //			registerDialog.btn_register.enableButton = false;

        this.registerDialog.btn_close.visible = this.layoutManager.inGameState;

        this.registerDialog.txt_title.text = Poker2Model.languageData.getTextById("generic_login_register");
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.registerDialog.btn_checkagb.txt_label, Poker2Model.languageData.getTextById("generic_register_btn_agb"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(13, this.registerDialog.btn_login.txt_label, Poker2Model.languageData.getTextById("login_btn_tologin"));
        this.registerDialog.btn_login.visible = !this.env.loginIsKeyBased && this.layoutManager.outGameState;

        this.registerDialog.btn_avatar.toolTipText = Poker2Model.languageData.getTextById("login_btn_changeavatar_tooltip");
        this.registerDialog.btn_avatar.visible = Poker2Model.avatarData.myAvatar != null && this.layoutManager.outGameState;
        this.registerDialog.mc_reward.txt_copy.text = Poker2Model.languageData.getTextById("menu_btn_register_tooltip");
        this.registerDialog.mc_reward.visible = this.layoutManager.inGameState;

        var format: TextFormat = this.registerDialog.btn_checkagb.txt_label.getTextFormat();
        format.underline = true;
        this.registerDialog.btn_checkagb.txt_label.setTextFormat(format);
    }

    protected onClick(event: MouseEvent): void {
        if (this.isWaitingForServerMessage)
            return;
        super.onClick(event);

        switch (event.target) {
            case this.registerDialog.txt_password:
            case this.registerDialog.txt_email:
            case this.registerDialog.txt_name:
                //					(event.target as TextField).setSelection( (event.target as TextField).text.length ), (event.target as TextField).text.length );
                this.hideNameSelection();
                break;
            case this.registerDialog.btn_close:
                if (!this.isLocked)
                    this.hide();
                break;
            case this.registerDialog.btn_login:
                if (!this.isLocked) {
                    this.hide();
                    this.layoutManager.state = BasicLayoutManager.STATE_LOGIN;
                }
                break;
            case this.registerDialog.btn_register:
                if (!this.isLocked) {
                    switch (this.isAllOkTextFieldWatcher()) {
                        case 0:
                            this.onRegister();
                            break;
                    }
                }
                break;
            case this.registerDialog.btn_guest:
                if (!this.isLocked)
                    this.onPlayNow();
                break;
            case this.registerDialog.btn_avatar:
                this.hide();
                this.layoutManager.showDialog("Poker2AvatarCreationDialog");
                break;
            case this.registerDialog.btn_agb:
                if (this.registerDialog.btn_agb.isSelected)
                    this.registerDialog.btn_agb.deselected();
                else
                    this.registerDialog.btn_agb.selected();
                break;
            case this.registerDialog.btn_checkagb:
                try {
                    var urlRequest: URLRequest = new URLRequest(this.env.urlAGB);
                    navigateToURL(urlRequest, "goodgamestudios");
                }
                catch (e) {
                }
                break;
        }
    }

    private saveFilledInputs(): void {
        if (this.registerDialog.txt_name.text != "" && this.registerDialog.txt_name.text != this.preset_name) {
            Poker2Model.registrationData.userName = this.registerDialog.txt_name.text;
        }
        else {
            Poker2Model.registrationData.userName = null;
        }

        if (this.registerDialog.txt_email.text != "" && this.registerDialog.txt_email.text != this.preset_mail) {
            Poker2Model.registrationData.email = this.registerDialog.txt_email.text;
        }
        else {
            Poker2Model.registrationData.email = null;
        }

        if (this.registerDialog.txt_password.text != "" && this.registerDialog.txt_password.text != this.preset_pass) {
            Poker2Model.registrationData.password = this.registerDialog.txt_password.text;
        }
        else {
            Poker2Model.registrationData.password = null;
        }

    }

    /**
     * Play as Guest
     */
    private onPlayNow(): void {
        if (!TextValide.isSmartFoxValide(this.registerDialog.txt_name.text)) {
            this.layoutManager.showDialog("Poker2WarningDialog", new BasicStandardOkDialogProperties(Poker2Model.languageData.getTextById("generic_register_title"), Poker2Model.languageData.getTextById("generic_register_namenotvalid")));
            return;
        }

        this.isWaitingForServerMessage = true;
        var guestName: string = Poker2Model.userData.guestName;

        if (guestName == "" || this.registerDialog.txt_name.text != this.preset_name)
            guestName = this.registerDialog.txt_name.text;

        BasicModel.smartfoxClient.sendMessage("lpn", [JSON.stringify({ name: guestName })]);
    }

    /**
     * Register
     */
    private onRegister(): void {
        if (this.registerDialog.txt_email.text == this.preset_mail || !TextValide.isSmartFoxValide(this.registerDialog.txt_email.text)) {
            this.showErrorBubble(24);
            return;
        }

        if (this.registerDialog.txt_name.text == this.preset_name || !TextValide.isSmartFoxValide(this.registerDialog.txt_name.text)) {
            this.showErrorBubble(28);
            return;
        }

        if (this.registerDialog.txt_password.text == this.preset_pass || !TextValide.isSmartFoxValide(this.registerDialog.txt_password.text)) {
            this.showErrorBubble(20);
            return;
        }

        if (this.registerDialog.txt_password.text.length < 4) {
            this.showErrorBubble(-1);
            return;
        }

        if (!this.registerDialog.btn_agb.isSelected) {
            this.showErrorBubble(-2);
            return;
        }
        this.isWaitingForServerMessage = true;
        var cmdVars: object = {
            email: this.registerDialog.txt_email.text.trim(),
            password: this.registerDialog.txt_password.text.trim(),
            username: this.registerDialog.txt_name.text.trim()
        };
        CommandController.instance.executeCommand(BasicController.COMMAND_REGISTER_USER, cmdVars);
    }

    public show(): void {
        this.hideNameSelection();
        this.isWaitingForServerMessage = false;
        this.enableTextFieldWatching();
        super.show();
    }

    public hide(): void {
        super.hide();
        this.disableTextFieldWatching();
    }

    private onRegisterFailed(e: Poker2UserEvent): void {
        this.isWaitingForServerMessage = false;
        this.showErrorBubble(e.params[0]);
    }

    private showErrorBubble(error: number): void {
        var bubbleTitle: string = Poker2Model.languageData.getTextById("generic_alert_watchout");
        var bubbleCopy: string = Poker2Model.languageData.getTextById("errorcode_" + error);

        switch (error) {
            case 28:
                bubbleTitle = Poker2Model.languageData.getTextById("generic_alert_watchout");
                bubbleCopy = Poker2Model.languageData.getTextById("alert_invalid_name");
                this.registerDialog.mc_errorbubble.y = this.registerDialog.mc_name.y;
                break;
            case 109:
                this.registerDialog.mc_errorbubble.y = this.registerDialog.mc_name.y;
                break;
            case 20:
                this.registerDialog.mc_errorbubble.y = this.registerDialog.mc_password.y;
                break;
            case 100:
            case 24:
            case 23:
                this.registerDialog.mc_errorbubble.y = this.registerDialog.mc_email.y;
                break;
            case 22:
                this.registerDialog.mc_errorbubble.y = this.registerDialog.mc_name.y;
                bubbleCopy = Poker2Model.languageData.getTextById("generic_register_namealreadyused");
                break;
            case -1:
                bubbleTitle = Poker2Model.languageData.getTextById("generic_register_title");
                bubbleCopy = Poker2Model.languageData.getTextById("generic_register_passwordshort_copy");
                this.registerDialog.mc_errorbubble.y = this.registerDialog.mc_password.y;
                break;
            case -2:
                bubbleTitle = Poker2Model.languageData.getTextById("generic_register_title");
                bubbleCopy = Poker2Model.languageData.getTextById("generic_register_agb_copy");
                this.registerDialog.mc_errorbubble.y = this.registerDialog.btn_agb.y;
            default:
                break;
        }
        TextFieldHelper.changeTextFromatSizeByTextWidth(10, this.registerDialog.mc_errorbubble.txt_title, bubbleTitle);
        TextFieldHelper.changeTextFromatSizeByTextWidth(10, this.registerDialog.mc_errorbubble.txt_copy, bubbleCopy, 4);
        this.registerDialog.mc_errorbubble.visible = true;
    }

    private onRegisterCompleted(e: BasicUserEvent): void {
        // ###

        this.isWaitingForServerMessage = false;

        if (e.params && e.params.length > 0 && e.params[0])
            Poker2Model.localData.saveLoginData(this.registerDialog.txt_name.text, this.registerDialog.txt_password.text.trim(), true);
        this.hide();
    }

    private onShowNameSuggestion(event: AvatarCreationEvent): void {
        this.registerDialog.mc_errorbubble.visible = false;
        this.lockDialog();
        this.isWaitingForServerMessage = false;

        if (this.nameSelectionToolTip == null) {
            this.nameSelectionToolTip = new Poker2NameSelection(new Library.PokerInterface.AvatarNameSelection(), this.registerDialog.mc_name);
            this.registerDialog.mc_name.addChild(this.nameSelectionToolTip.disp);
            this.nameSelectionToolTip.disp.y = 5;
            this.nameSelectionToolTip.disp.x = 10;
        }
        this.nameSelectionToolTip.showNames(event.params[0]);
        this.nameSelectionToolTip.disp.addEventListener("avatarnameselected", this.bindFunction(this.onNameSelected));
        this.registerDialog.txt_name.addEventListener(TextEvent.TEXT_INPUT, this.bindFunction(this.onTextFieldChange));
    }

    private onTextFieldChange(event: TextEvent): void {
        this.hideNameSelection();
    }

    private onNameSelected(event: AvatarCreationEvent): void {
        this.hideNameSelection();
        this.nameSelectionToolTip.disp.removeEventListener("avatarnameselected", this.bindFunction(this.onNameSelected));
        this.registerDialog.txt_name.text = event.params.shift();
        this.registerDialog.txt_name.alpha = InputFieldConstants.INPUT_FILLED_ALPHA;
    }

    private hideNameSelection(): void {
        if (this.nameSelectionToolTip)
            this.nameSelectionToolTip.hide();
        // wegen TextFieldWatcher nicht hiden, wenn ein text vorliegt
        if (this.registerDialog.mc_errorbubble.txt_copy.text.length <= 1)
            this.registerDialog.mc_errorbubble.visible = false;

        this.unLockDialog();
        this.registerDialog.txt_name.removeEventListener(TextEvent.TEXT_INPUT, this.bindFunction(this.onTextFieldChange));
    }

    public destroy(): void {
        this.controller.removeEventListener(BasicUserEvent.REGISTERED, this.bindFunction(this.onRegisterCompleted));
        this.controller.removeEventListener("avatarnamesuggestions", this.bindFunction(this.onShowNameSuggestion));
        this.controller.removeEventListener("registerFailed", this.bindFunction(this.onRegisterFailed));
        this.hideNameSelection();

        this.registerDialog.txt_name.removeEventListener(TextEvent.TEXT_INPUT, this.bindFunction(this.onEnterUsername));
        this.registerDialog.txt_email.removeEventListener(TextEvent.TEXT_INPUT, this.bindFunction(this.onEnterEmail));
        this.registerDialog.txt_password.removeEventListener(TextEvent.TEXT_INPUT, this.bindFunction(this.onEnterPassword));
        this.registerDialog.txt_email.removeEventListener(FocusEvent.FOCUS_IN, this.bindFunction(this.onEnterEmail));
        this.registerDialog.txt_password.removeEventListener(FocusEvent.FOCUS_IN, this.bindFunction(this.onEnterPassword));
        this.registerDialog.txt_name.removeEventListener(FocusEvent.FOCUS_IN, this.bindFunction(this.onEnterUsername));
        this.registerDialog.txt_email.removeEventListener(FocusEvent.FOCUS_OUT, this.bindFunction(this.refillEmptyInputFields));
        this.registerDialog.txt_password.removeEventListener(FocusEvent.FOCUS_OUT, this.bindFunction(this.refillEmptyInputFields));
        this.registerDialog.txt_name.removeEventListener(FocusEvent.FOCUS_OUT, this.bindFunction(this.refillEmptyInputFields));
        super.destroy();
    }

    /**
     * TextFieldWatcher
     *
     * das system erwartet, das man zu jedem eingabefeld eine eigene fehleranzeige besitzt
     * das hat poker2 nicht und soll auch so nicht sein.
     * deshalb wird nur das email-feld im client getestet
     */

    private enableTextFieldWatching(): void {
        TextFieldWatcher.watchTextField(this.registerDialog.txt_name, TextFieldWatcher.RULE_TEXT, this.bindFunction(this.onUserNameInput));
        TextFieldWatcher.watchTextField(this.registerDialog.txt_password, TextFieldWatcher.RULE_TEXT, this.bindFunction(this.onPasswordInput));
        TextFieldWatcher.watchTextField(this.registerDialog.txt_email, TextFieldWatcher.RULE_EMAIL, this.bindFunction(this.onEmailInput));
    }

    private disableTextFieldWatching(): void {
        TextFieldWatcher.stopWatchingTextField(this.registerDialog.txt_name);
        TextFieldWatcher.stopWatchingTextField(this.registerDialog.txt_password);
        TextFieldWatcher.stopWatchingTextField(this.registerDialog.txt_email);
    }

    private isAllOkTextFieldWatcher(): number {
        var errorNo: number = 0;
        //
        errorNo = int(TextFieldWatcher.validateString(this.registerDialog.txt_name.text, TextFieldWatcher.RULE_TEXT, 0));
        if (errorNo) {
            this.onUserNameInput(errorNo);
            return errorNo;
        }
        errorNo = int(TextFieldWatcher.validateString(this.registerDialog.txt_password.text, TextFieldWatcher.RULE_TEXT, 0));
        if (errorNo) {
            this.onPasswordInput(errorNo);
            return errorNo;
        }
        errorNo = int(TextFieldWatcher.validateString(this.registerDialog.txt_email.text, TextFieldWatcher.RULE_EMAIL, 0));
        if (errorNo) {
            this.onEmailInput(errorNo);
            return errorNo;
        }

        //			registerDialog.btn_register.enableButton = ok!=0;
        return errorNo;
    }

    private onUserNameInput(watcherErrorcode: number): void {
        switch (watcherErrorcode) {
            case TextFieldWatcher.ERRORCODE_ALL_OK:
                if (this.lastTextFieldWatcherType != 1)
                    this.registerDialog.mc_errorbubble.visible = false;
                break;
            case TextFieldWatcher.ERRORCODE_INVALID_CHARS:
            case TextFieldWatcher.ERRORCODE_TOO_SHORT:
                this.showError(0, Poker2Model.languageData.getTextById("generic_register_namenotvalid"));
                break;
        }
    }

    private onPasswordInput(watcherErrorcode: number): void {
        switch (watcherErrorcode) {
            case TextFieldWatcher.ERRORCODE_ALL_OK:
                if (this.lastTextFieldWatcherType != 1)
                    this.registerDialog.mc_errorbubble.visible = false;
                break;
            case TextFieldWatcher.ERRORCODE_INVALID_CHARS:
                this.showError(2, Poker2Model.languageData.getTextById("generic_register_password_copy"));
                break;
            case TextFieldWatcher.ERRORCODE_TOO_SHORT:
                this.showError(2, Poker2Model.languageData.getTextById("generic_register_passwordshort_copy"));
                break;
        }
    }

    private onEmailInput(watcherErrorcode: number): void {
        switch (watcherErrorcode) {
            case TextFieldWatcher.ERRORCODE_ALL_OK:
                this.registerDialog.mc_errorbubble.visible = false;
                break;
            case TextFieldWatcher.ERRORCODE_NO_EMAIL:
                this.showError(1, Poker2Model.languageData.getTextById("generic_register_emailwrong_copy"));
                break;
            case TextFieldWatcher.ERRORCODE_INVALID_CHARS:
            case TextFieldWatcher.ERRORCODE_TOO_SHORT:
                this.showError(1, Poker2Model.languageData.getTextById("generic_register_email_copy"));
                break;
        }
    }

    private showError(type: number, text: string = ""): void {
        if (text) {
            switch (type) {
                case 0:
                    this.showErrorBubble(28);
                    break;
                case 2:
                    this.showErrorBubble(20);
                    break;
                case 1:
                    this.showErrorBubble(24);
                    break;
                case 3:
                    break;
            }
            TextFieldHelper.changeTextFromatSizeByTextWidth(10, this.registerDialog.mc_errorbubble.txt_copy, text, 4);
        }
        this.lastTextFieldWatcherType = type;
    }

    public static __initialize_static_members() {
        Poker2RegisterDialog.NAME = CommonDialogNames.RegisterDialog_NAME;
    }
}
import { AvatarHelper } from "../../helper/AvatarHelper";
import { Poker2WarningDialog } from "../Poker2WarningDialog";
import { Poker2AvatarCreationDialog } from "./Poker2AvatarCreationDialog";

Poker2RegisterDialog.__initialize_static_members();
